module.exports = __webpack_public_path__ + "static/media/comm5.68aab42a.jpg";